var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIntegration16Blue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66683 3.99967H1.3335V13.333C1.3335 14.0663 1.9335 14.6663 2.66683 14.6663H12.0002V13.333H2.66683V3.99967ZM13.3335 1.33301H5.3335C4.60016 1.33301 4.00016 1.93301 4.00016 2.66634V10.6663C4.00016 11.3997 4.60016 11.9997 5.3335 11.9997H13.3335C14.0668 11.9997 14.6668 11.3997 14.6668 10.6663V2.66634C14.6668 1.93301 14.0668 1.33301 13.3335 1.33301ZM12.6668 7.33301H10.0002V9.99967H8.66683V7.33301H6.00016V5.99967H8.66683V3.33301H10.0002V5.99967H12.6668V7.33301Z",
    fill: "#0077CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIntegration16Blue);
export default __webpack_public_path__ + "static/media/icon-integration-16-blue.853f3e09da3a2af3bdec2b66034c31b0.svg";
export { ForwardRef as ReactComponent };